import React, { useEffect } from "react";
import { UrgentVisitModalContent } from "./UrgentVisitModalContent";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import {
  useUrgentVisitStore,
} from "../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";
import { UrgentVisitStep } from "../../../state/urgent-visit";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useModal } from "../../../context/ModalContext";
import { MODALS } from "../../../config/params";

const UrgentVisitModal = () => {
  const { petList } = usePetStore();
  const { user } = useUserStore();
  const {
    homeLocationId, setHomeLocationId, setIsMultiPetOwner,
    setSelectedPets, setStep, currentStep,
  } = useUrgentVisitStore();
  const { openModal } = useModal();

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.URGENT_VISIT_INITIATE, {
      appointment_category: "urgent",
      owner_type: petList && petList.length > 1 ? "multipet" : "single_pet",
    });

    const locId = user?.location?.idLocation || "";

    if (locId && locId !== homeLocationId) {
      setHomeLocationId(locId);
    }

    if (petList) {
      if (petList.length === 0) {
        openModal(MODALS.ADD_A_PET);
        return;
      }

      const isMulti = petList.length > 1;

      setIsMultiPetOwner(isMulti);

      if (!isMulti && petList.length === 1) {
        setSelectedPets(petList);
        if (currentStep === UrgentVisitStep.PET_SELECTION) {
          setStep(UrgentVisitStep.TIME_SELECTION);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!petList) return null;

  return <UrgentVisitModalContent />;
};

export default UrgentVisitModal;
